import { render, staticRenderFns } from "./Offering.vue?vue&type=template&id=6123584a&scoped=true"
import script from "./Offering.vue?vue&type=script&lang=js"
export * from "./Offering.vue?vue&type=script&lang=js"
import style0 from "./Offering.vue?vue&type=style&index=0&id=6123584a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6123584a",
  null
  
)

export default component.exports